var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo",attrs:{"src":_vm.logoUrl,"alt":""},on:{"click":_vm.goHome}})
}
var staticRenderFns = []

export { render, staticRenderFns }